import { render, staticRenderFns } from "./FormMitra.vue?vue&type=template&id=4675c690&"
import script from "./FormMitra.vue?vue&type=script&lang=js&"
export * from "./FormMitra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports